import { render, staticRenderFns } from "./CreatDsGroup.vue?vue&type=template&id=726b5a6e"
import script from "./CreatDsGroup.vue?vue&type=script&lang=js"
export * from "./CreatDsGroup.vue?vue&type=script&lang=js"
import style0 from "./CreatDsGroup.vue?vue&type=style&index=0&id=726b5a6e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726b5a6e')) {
      api.createRecord('726b5a6e', component.options)
    } else {
      api.reload('726b5a6e', component.options)
    }
    module.hot.accept("./CreatDsGroup.vue?vue&type=template&id=726b5a6e", function () {
      api.rerender('726b5a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/group/CreatDsGroup.vue"
export default component.exports